import { IUserInfo } from './IUserInfo';
import { IExplorableItemTypeInfo, IIdItemInfo, IScheduledItemInfo, ISiteItemInfo } from './resourceInfoParts';
import { PdfPageSizeServerString, PageOrientationServerString } from '../../app/content/SubscriptionChangeFormatDialog';
import { CreatorUserStatus } from '../ServerApi/types/SubscriptionCreatorUserStatus';

export let SubscriptionTargetTypes = {
  view: 'view',
  workbook: 'workbook'
};

export interface ISubscriptionInfo extends IIdItemInfo, IScheduledItemInfo, ISiteItemInfo, IExplorableItemTypeInfo<'subscription'> {
  subject: string;
  user: IUserInfo;
  lastSentAt?: Date;
  runNextAt?: Date;

  canSpecifyDataCondition: boolean;
  dataConditionPresent: boolean;

  targetId: string;
  targetName: string;
  targetType: string;
  targetPath: string;
  creator: IUserInfo;
  canManageSubscription: boolean;

  lastRunError?: string;
  failed?: boolean;
  suspended?: boolean;

  attachImage?: boolean;
  attachPdf?: boolean;

  pageSizeOption?: PdfPageSizeServerString;
  pageOrientation?: PageOrientationServerString;

  refreshExtractTriggered?: boolean;

  creatorUserStatus: CreatorUserStatus;
}
